module.exports = __webpack_public_path__ + "img/lvl4.0191277.svg";